<template>
    <el-dialog
        :title="payType ? '支付宝支付' : '微信支付' "
        v-show="show"
        class="paymodal"
        :visible.sync="show"
        width="700px"
        :close-on-click-modal="false"
        :before-close="handleClose">
        <div :class="payType ? 'payForAli' : 'payForWeixin'">注意：出行券账户用于购买出行券，暂不支持企业支付用车</div>
        <div class="payleft">
            <div class="title">{{ type ? '充值': '支付' }}金额</div>
            <div class="amount"><span>{{amount}}</span>元</div>
            <VueQrcode class="qrimg" :value="payLinkInfo.url" :options="{ size: 260 ,padding:20}"></VueQrcode>
            <div >请使用{{payType ? '支付宝' : '微信'}}</div>
            <div >扫描二维码完成支付</div>
            <button class="freshbtn" @click="refreshLink">刷新二维码</button>
        </div>
        <div class="payright"
            v-bind:class="{ rightimgali: payType}">
        </div>
    </el-dialog>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import VueQrcode from '@xkeshi/vue-qrcode'

export default {
  name: 'payModal',
  data () {
    return {
      show: this.showModal,
      id: ''
    }
  },
  props: {
    payType: '', // 0微信，1支付宝
    showModal: '',
    type: '', // 0充值，1订单支付
    amount: '',
    orderId: ''
  },
  created () {
    this.getPayLink({type: this.type, channel: this.payType ? 128 : 127, amount: this.amount, orderId: this.orderId})
  },
  mounted () {

  },
  components: {VueQrcode},
  computed: {
    ...mapState('couponPay', ['payLinkInfo', 'pollingStatus'])
  },
  methods: {
    ...mapActions('couponPay', ['getPayLink', 'pollingPayStatus', 'stopPolling']),
    handleClose () { // 关闭弹窗
      this.$emit('close')
    },
    refreshLink () { // 刷新二维码
      // 先停止之前的轮询
      this.stopPolling()
      this.getPayLink({type: this.type, channel: this.payType ? 128 : 127, amount: this.amount, orderId: this.orderId})
    }
  },
  watch: {
    payLinkInfo: function (value) {
      if (value) {
        this.id = value.id
        this.pollingPayStatus({id: value.id})
      }
    },
    pollingStatus: function (value) { // 返回非轮询状态
      if (value) {
        if (this.type === 1) { // 订单支付
          this.$router.push({path: 'paynext', query: {orderId: this.orderId, status: value}}).catch(err => {})
        } else { // 充值
          this.$emit('close', value)
        }
      }
    }
  }
}
</script>
<style  lang="stylus">
    .paymodal{
        .payForWeixin {
          color: red;
          position: absolute;
          left: 17%;
          bottom: 90%;
        }
        .payForAli {
          color: red;
          position: absolute;
          left: 20%;
          bottom: 90%;
        }
        .payleft{
            display: inline-block;
            width: 320px;
            text-align:center
            font-size: 14px;
            color: #333333;
            position: relative;
            top: -19px;
            .title{
                margin-bottom: 0px;
                border: none;
                font-size:14px;
                position: relative;
                left: -15px;
                height: 50px;
            }
            .amount{
                margin-bottom: 5px;
                span{
                    font-size: 40px;
                    color: #FC6F53;
                }
            }
            .qrimg{
                
                margin-bottom:5px
            }
            .freshbtn{
                margin-top:20px;
                border: 2px solid #3468FF;
                width: 130px;
                height: 44px;
                color: #3468FF;
                cursor: pointer;
                background-color: #fff;
            }
        }
        .payright {
            display: inline-block;
            background: url('../images/pay_img_weipay.jpg');
            background-size: 223px 370px;
            width: 295px;
            height: 370px;
            background-repeat: no-repeat;
            position: relative;
            left: 10px;
        }
        .rightimgali {
            background: url('../images/pay_img_alipay.jpg');
            background-size: 223px 370px;
            width: 295px;
            height: 370px;
            background-repeat: no-repeat;
            position: relative;
            left: 10px;
        }
        .el-dialog__title{
          margin-left:10px;
          margin-top:10px;
          display: inline-block;
          color:#333;
          font-size:20px;
        }
    }
</style>
